import type {BuilderInlet} from "#template/runtime-graph/graph-builder"
import type {GraphBuilderScope} from "#template/runtime-graph/graph-builder-scope"
import {createFundamentalMarker} from "#template/role-markers"
import type {NodeEvaluator} from "#template/node-evaluator"
import type {ObjectLikeNode} from "#template/nodes/object/fundamental"
import type {MeshObjectData} from "#template/nodes/object/mesh/types"

export const meshLikeMarker = Symbol("MeshLike")

// `evaluate` is redeclared to narrow the return from `BuilderInlet<ObjectData | null>` to
// `BuilderInlet<MeshObjectData | null>`. Multi-extends with two `EvaluableTemplateNode<...>` parents
// hits TS2320 — TS won't merge differing `evaluate` signatures.
export interface MeshLikeNode extends ObjectLikeNode {
    readonly [meshLikeMarker]: true
    evaluate(scope: GraphBuilderScope, evaluator: NodeEvaluator): BuilderInlet<MeshObjectData | null>
}

export const meshMarker = createFundamentalMarker<MeshLikeNode>(meshLikeMarker)
export const {isLikeNode: isMeshLikeNode, isLikeNodeClass: isMeshLikeNodeClass, like: meshLike} = meshMarker
